var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4706 1.29692C10.9409 0.767586 10.0868 0.767694 9.55729 1.29724L1.23704 9.61749C0.807509 10.047 0.807509 10.7411 1.23704 11.1706L9.55729 19.4909C10.0869 20.0206 10.9412 20.0206 11.4709 19.4909C12.0006 18.9612 12.0006 18.107 11.4709 17.5773L4.29263 10.3891L11.4809 3.20083C12.0005 2.68121 12.0007 1.81665 11.4706 1.29692Z",
    fill: "#27374D",
    stroke: "#47515A",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.fd3b4861371014a328265f82fa2b4363.svg";
export { ForwardRef as ReactComponent };